import { __assign } from "tslib";
import React from 'react';
import { SvgIcon } from './internal/SvgIcon';
export var Video = function Video(props) {
  return React.createElement(SvgIcon, __assign({}, props), React.createElement("svg", {
    viewBox: "0 0 16 16"
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.5 8.50495L5.99706 5.50397V11.5059L11.5 8.50495ZM4.49999 13.003C3.81184 13.003 3.22396 12.7592 2.73633 12.2715C2.24869 11.7839 2.0026 11.1938 1.99805 10.501V6.50202C1.99805 5.81386 2.24414 5.22598 2.73633 4.73834C3.22851 4.25071 3.8164 4.00462 4.49999 4.00006H11.5C12.1881 3.99551 12.776 4.23932 13.2636 4.73151C13.7513 5.2237 13.9973 5.81386 14.0019 6.50202V10.501C14.0019 11.1846 13.7558 11.7725 13.2636 12.2647C12.7714 12.7569 12.1836 13.003 11.5 13.003H4.49999Z",
    clipRule: "evenodd"
  })));
};